import { GRANULARITY } from '@linearb/linjs-common';

export { GRANULARITY };
export const GRANULARITY_TO_METRICS_SEARCH_GRANULARITY = {
  [GRANULARITY.AUTO]: '1d',
  [GRANULARITY.DAYS]: '1d',
  [GRANULARITY.WEEKS]: '1w',
  [GRANULARITY.MONTHS]: '1mo',
  [GRANULARITY.ITERATIONS]: 'custom'
};
